var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdvantages1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFA516",
    cx: 22.5,
    cy: 22.5,
    r: 22.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9995582,18.3512486 C23.9037985,18.2235689 23.8080786,18.1278491 23.7123388,18.0640092 L15.2552364,12.4791408 C14.457398,11.9366219 13.5,12.6068205 13.5,13.5961384 L13.5,24.7658553 C13.5,25.8190131 14.4893179,26.4253718 15.2552364,25.9147529 L23.7123388,20.3298845 C24.3825174,19.8830854 24.5101771,18.9576073 23.9995582,18.3512486 Z M31.4992227,31.4038616 L31.4992227,20.2341447 C31.4992227,19.2129068 30.5099047,18.5746282 29.7439863,19.0852471 L21.2869038,24.6701155 C21.1911441,24.7339553 21.0954242,24.8296951 20.9996844,24.9573349 C20.5209854,25.5636937 20.6486252,26.4891917 21.2869038,26.9359708 L29.7759062,32.5208592 C30.5737446,33.0633781 31.5311426,32.3931795 31.4992227,31.4038616 Z",
    id: "\\u5F62\\u72B6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantages1);
export default __webpack_public_path__ + "static/media/advantages1.svg";
export { ForwardRef as ReactComponent };